export default __webpack_public_path__ + "static/media/Icon55.7a8c5ed2.svg";